import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import type {
  CallerContext,
  CardTokenType,
  PaymentDetail,
  PayorInformationFormValues,
} from '../types/paymentService.types';

const paymentServiceSlice = createSlice({
  initialState,
  name: 'PaymentService',
  reducers: {
    initPayment(
      state,
      action: PayloadAction<{
        callerContext: CallerContext;
        paymentDetails: PaymentDetail[];
        totalAmount: number;
      }>
    ) {
      state.paymentDetails = action.payload.paymentDetails;
      state.callerContext = action.payload.callerContext;
      state.totalAmount = action.payload.totalAmount;
      state.paymentReceipt = initialState.paymentReceipt;
    },

    setPaymentReceipt: (state, action: PayloadAction<{ checkStatusURL: string; referenceNumber: string }>) => {
      state.paymentReceipt = action.payload;
    },
    resetPaymentReceipt: (state) => {
      state.paymentReceipt = initialState.paymentReceipt;
    },
    resetStatePayments: (state) => {
      state.paymentDetails = initialState.paymentDetails;
      state.totalAmount = initialState.totalAmount;
    },
    resetStatePayorInformation: (state) => {
      state.payorInformation = initialState.payorInformation;
    },
    setPayorInformation(state, action: PayloadAction<PayorInformationFormValues>) {
      state.payorInformation = action.payload;
    },
    setSelectedTokenizedCard(state, action: PayloadAction<CardTokenType>) {
      state.selectedTokenizedCard = action.payload;
    },
    resetSelectedTokenizedCard(state) {
      state.selectedTokenizedCard = initialState.selectedTokenizedCard;
    },
  },
});

export const { actions: paymentServiceAction } = paymentServiceSlice;

export default paymentServiceSlice.reducer;
